export const UPDATE_LOGIN = "UPDATE_LOGIN";
export const UPDATE_MAIN = "UPDATE_MAIN";
export const SIGN_FAILED = "SIGN_FAILED";
export const SIGN_SUCCESS = "SIGN_SUCCESS";
export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS";
export const SIGNUP_FAIL = "SIGNUP_FAIL";
export const FORGET_SUCCESS = "FORGET_SUCCESS";
export const FORGET_FAILED = "FORGET_FAILED";
export const LOAD_PROFILE = "LOAD_PROFILE";
export const STORE_SECRET = "STORE_SECRET";
export const VERIFY_SOCIALUSER = "VERIFY_SOCIALUSER";
export const API_ACCESS_TOKEN = "API_ACCESS_TOKEN";
export const GET_ALL_TOKENS = "GET_ALL_TOKENS";
export const DELETE_TOKEN = "DELETE_TOKEN";
export const IS_LOADING = "IS_LOADING";